import Joi from 'joi';

export const registrationCleanerStep2Validator = Joi.object({
  has_experience: Joi.string().required().messages({
    'string.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
  }),
  years_of_experience: Joi.number().required().messages({
    'number.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
    'number.base': 'Поле \'age\' повинно містити тільки цифри',
  }),
  prevPlaceWork: Joi.string().required().messages({
    'string.empty': 'Заповніть це поле',
    'any.required': 'Заповніть це поле',
  }),
});
